import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { message } from '@docon/docon-ui-library';
import apis, { Apis } from 'apis/index';
import { storageService } from 'services';

export const createAsyncAction = (type: string, fuName: keyof Apis) => createAsyncThunk<any, any>(
  type,
  async (payload, thunkAPI) => {
    try {
      return await apis[fuName](payload);
    } catch (error) {
      const err: any = error;
      console.log('errors :>> ', err?.response?.data);
      if (err?.response?.data?.errors?.accessToken) {
        // Retrieve the 'isPEWebView' value from the storageService to check if the app is running in a PE WebView environment
        storageService.get(storageService.isPEWebView).then((isPEWebView) => {
          // Initialize the default location to the root path
          let location = '/';
          // If the app is running in a PE WebView, set the location to the error page
          if (isPEWebView) {
            location = '/patientmweb/error';
          }
          // Clear the storage and then redirect the user to the determined location
          storageService.clear().then(() => {
            window.location.href = location;
          });
        });
      } else if (err.message === 'Network Error') {
        message.error(err.message, { autoClose: 2000 });
      } else if (axios.isCancel(error)) {
        err.name = 'AbortError';
        throw err;
      }

      return thunkAPI.rejectWithValue(err?.response?.data || {});
    }
  },
);